import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-8 h-8 flex items-center justify-center text-primary-500">
                <i className="ri-football-line text-2xl"></i>
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                2026世界杯
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              2026美加墨世界杯官方信息聚合平台，为您提供超清直播、实时资讯与合规平台导航服务。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
              快速导航
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  赛事直播
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  赛程赛果
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  新闻资讯
                </Link>
              </li>
              <li>
                <Link to="/category/all" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  平台评测
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
              关于我们
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about#reputation" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  信誉展示
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-background-50 mb-4">
              安全声明
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              本站仅提供信息聚合与平台导航服务，所有推荐平台均持有合法运营牌照。请理性参与，量力而行。
            </p>
            <div className="flex gap-3 mt-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 text-sm cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-shield-check-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 text-sm cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-lock-line"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 text-sm cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-colors">
                <i className="ri-verified-badge-line"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 ZL5.net - 2026世界杯官方信息聚合平台。保留所有权利。
          </p>
          <p className="text-xs text-background-600">
            理性投注 | 健康观赛 | 18+
          </p>
        </div>
      </div>
    </footer>
  );
}